export const isIOSWebView = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  const isIOS = /iphone|ipad|ipod/.test(userAgent);
  // Chrome and Firefox on iOS keep "safari" in their UA and run Google One Tap, only real WebViews drop it
  const isWebView = /wkwebview/.test(userAgent) || (isIOS && !/(safari)/.test(userAgent));

  return isIOS && isWebView;
};

export function isElectronEnvironment() {
  // Check for typical Electron environment indicators
  const isElectron = (
    typeof window !== 'undefined' &&
    (
      // @ts-expect-error window.process exists only in Electron
      window.process && window.process.type === 'renderer' ||
      typeof window.process?.versions?.electron !== 'undefined' ||
      typeof window.require === 'function' ||
      navigator.userAgent.toLowerCase().indexOf('electron/') > -1
    )
  );

  return isElectron;
}
